// src/api/storybook.js
// Calls your HTTP function. No auth required.

const REGION = "us-central1";
const PROJECT_ID = "scan-cap"; // <-- change if your Firebase project id differs

const BASE = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/createStorybookCheckout`;

export async function startStorybookCheckout({
  eventId,
  successUrl,
  cancelUrl,
  quantity = 1,
  photoCount = 60,
  priceId,          // optional manual override
  customerEmail,    // optional prefill
}) {
  const res = await fetch(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      eventId,
      success_url: successUrl,
      cancel_url: cancelUrl,
      quantity,
      photoCount,
      priceId,
      customer_email: customerEmail || undefined,
    }),
  });

  const json = await res.json();
  if (!res.ok || !json?.url) {
    throw new Error(json?.error || "Checkout failed");
  }
  window.location.assign(json.url);
}
